import { render, staticRenderFns } from "./facebookIcon.vue?vue&type=template&id=2c5504b1&scoped=true"
import script from "./facebookIcon.vue?vue&type=script&lang=js"
export * from "./facebookIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5504b1",
  null
  
)

export default component.exports